import { USER_TYPE } from "../constants";

const userReducer = (state = {
   userAccessToken: ''
}, action) => {
   switch (action.type) {
      case USER_TYPE.LOGIN:
         return action.payload;
      case USER_TYPE.LOGOUT:
         return action.payload;
      default:
         return state;
   }
};
export default userReducer;